import moment from 'moment'
import { getWorkspaceName } from '../session/sessionStorage'
import { curry } from 'ramda'
import { getSubdomain } from './url'

export const genResumeUrl = (serviceOrder = {}) => {
  const { resumeToken, resumeURL, id } = serviceOrder
  if (!!resumeURL) return resumeURL
  if (!resumeToken) return false
  const ws = getWorkspaceName()
  return `https://${ws}.btime.io/resume/${id}?t=${resumeToken}`
}

// Public (QR-code history) URL variants. Unlike genResumeUrl these are built against the
// current host instead of getWorkspaceName(), because on the unauthenticated public history
// page the workspace name is not available in localStorage. The resumeToken is the permalink
// token that grants public, unauthenticated read access to the service order.
export const genPublicResumeUrl = (serviceOrder = {}) => {
  const { resumeToken, id } = serviceOrder
  if (!id || !resumeToken) return false
  // Absolute URL so it can be shared as-is (WhatsApp, e-mail, etc.).
  return `${window.location.origin}/resume/${id}?t=${resumeToken}`
}

export const genPdfUrl = (serviceOrder = {}) => {
  const { resumeToken, id } = serviceOrder
  if (!id || !resumeToken) return false
  // Relative URL — resolves against the current host, opened in a new tab.
  return `/service-orders/${id}/pdf?t=${resumeToken}`
}

export const genExecutionUrl = (serviceOrder = {}) => {
  const { executionToken, id } = serviceOrder
  if (!executionToken) return false
  const ws = getWorkspaceName()
  return `https://${ws}.btime.io/service-orders/${id}/execution?t=${executionToken}`
}

export const shouldIncrementCheckout = (serviceOrder = {}) => {
  const { place, startDate, endDate } = serviceOrder
  const elapsedTime = moment(endDate).diff(startDate)
  const lastedLessThanOneHour = elapsedTime < 3600000
  const workspace = getSubdomain()
  return (
    workspace === 'segurpronovo' &&
    (place?.placeLevelIds?.includes(8393) || place?.placeLevelIds?.includes(17059)) &&
    lastedLessThanOneHour
  )
}

export const shouldHideIndicators = (serviceOrder = {}) => {
  const { place } = serviceOrder
  const workspace = getSubdomain()
  return workspace === 'segurpronovo' && (place?.placeLevelIds?.includes(8393) || place?.placeLevelIds?.includes(17059))
}

export const incrementCheckout = curry(checkOutDate => {
  return moment(checkOutDate).add(1, 'hour')
})
